import { render, staticRenderFns } from "./EstadisticasCategorias.vue?vue&type=template&id=d6f187fa&scoped=true&lang=pug"
import script from "./EstadisticasCategorias.vue?vue&type=script&lang=js"
export * from "./EstadisticasCategorias.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCategorias.vue?vue&type=style&index=0&id=d6f187fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f187fa",
  null
  
)

export default component.exports